const VueMasonryPlugin = window["vue-masonry-plugin"].VueMasonryPlugin;
const rootEl = document.getElementById('collectionApp');
const productComponent = {
    components: {
        'wishlist': wishlistLink,
    },
    inject: ['type','active'],
    emits: ['openSamplePopup','activate'],
    data() {
        return {
            exploreGridId: 'exploreGrid',
        }
    },
    created() {},
    template: `<div class="item" :class="{'active': active === product.id}" @click="$emit('activate', (active === product.id ? 0 : product.id))" v-masonry-tile>
        <div class="item-wrapper">
            <wishlist :id="product.id" :is-product-page="false" :type="'API ' + this.type" :url="null" :image="imageUrl" :title="product.title"></wishlist>
            <img :src="imageUrl" alt="" loading="lazy" :height="height" :width="width">
            <div class="item-details">
                <p>Item # {{product.id}}</p>
                <p><button type="button" class="product-form__add-button button button--primary button--full" @click.stop.prevent="$emit('openSamplePopup', product)">Order Sample</button></p>
            </div>
        </div>
    </div>`,
    props: {
        product: Object
    },
    computed: {
        imageUrl() {
            return (this.type === 'canvas') ? this.previewUrl + this.product.thumbnail_url : this.product.thumbnail_url;
        },
        height() {
            return (this.type === 'canvas') ? 600 : Math.round(this.product.thumbnail_height * 1);
        },
        width() {
            return (this.type === 'canvas') ? 600 : Math.round(this.product.thumbnail_width * 1);
        },
        productTitle() {
            let title = this.product.title.toLowerCase().replace(/\./g, ' ');
            if(title.indexOf('wall mural') === -1) {
                title += ' wall mural';
            }
            return title;
        },
    },
    methods: {}
}
const filtersComponent = {
    inject: ['appliedFilters','cleanFilters','loading'],
    emits: ['updateFilters'],
    data() {
        return {
            filters: {
                'type': {
                    'all': 'All',
                    'photo': 'Photos',
                    'illustration': 'Illustrations',
                    'vector': 'Vectors',
                },
                'orientation': {
                    'all': 'All',
                    'horizontal': 'Horizontal',
                    'vertical': 'Vertical',
                    'square': 'Square',
                    'panoramic': 'Panoramic',
                },
                'size': {
                    'units': {
                        'inches': 'Inches',
                        'centimeters': 'Centimeters',
                    }
                }
            },
            open: false,
            openFilters: {
                'type': false,
                'orientation': false,
                'size': false,
                'color': false,
            },
            activeFilters: this.cloneObject(this.appliedFilters),
            colors: ['#330000','#331900','#333300','#193300','#003300','#003319','#003333','#001933','#000033','#190033','#330033','#330019','#000000','#660000','#663300','#666600','#336600','#006600','#006633','#006666','#003366','#000066','#330066','#660066','#660033','#202020','#990000','#994C00','#999900','#4C9900','#009900','#00994C','#009999','#004C99','#000099','#4C0099','#990099','#99004C','#404040','#CC0000','#CC6600','#CCCC00','#66CC00','#00CC00','#00CC66','#00CCCC','#0066CC','#0000CC','#6600CC','#CC00CC','#CC0066','#606060','#FF0000','#FF8000','#FFFF00','#80FF00','#00FF00','#00FF80','#00FFFF','#0080FF','#0000FF','#7F00FF','#FF00FF','#FF007F','#808080','#FF3333','#FF9933','#FFFF33','#99FF33','#33FF33','#33FF99','#33FFFF','#3399FF','#3333FF','#9933FF','#FF33FF','#FF3399','#A0A0A0','#FF6666','#FFB266','#FFFF66','#B2FF66','#66FF66','#66FFB2','#66FFFF','#66B2FF','#6666FF','#B266FF','#FF66FF','#FF66B2','#C0C0C0','#FF9999','#FFCC99','#FFFF99','#CCFF99','#99FF99','#99FFCC','#99FFFF','#99CCFF','#9999FF','#CC99FF','#FF99FF','#FF99CC','#E0E0E0','#FFCCCC','#FFE5CC','#FFFFCC','#E5FFCC','#CCFFCC','#CCFFE5','#CCFFFF','#CCE5FF','#CCCCFF','#E5CCFF','#FFCCFF','#FFCCE5','#FFFFFF']
        }
    },
    mounted() {

    },
    computed: {
        hasApplied() {
            for(const filter in this.appliedFilters) {
                if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                    return true;
                }
            }
            return false;
        },
        countApplied() {
            let count = 0;
            for(const filter in this.appliedFilters) {
                if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                    count++
                }
            }
            return count;
        },
        mobileFiltersTitle() {
            if(this.countApplied > 0) {
                return 'Filters (' + this.countApplied + ')';
            } else {
                return 'Filters';
            }
        }
    },
    template: `
    <a href="#" class="toggle-mobile-filters" :class="{'active': hasApplied}" @click.prevent="open = !open" v-text="mobileFiltersTitle"></a>
    <div class="filters-container" :class="{'open': open, 'loading': loading}">
    <ul class="shop-filters">
        <li class="label">Filter by:</li>
        <li :class="{'open': openFilters.type}">
            <a href="#" class="toggle-filter" @click.prevent="openFilters.type = !openFilters.type">Type</a>
            <ul>
                <li v-for="(value, key, index) in filters.type"><input type="radio" :value="key" :id="'image-type-'+index" v-model="activeFilters.type"> <label :for="'image-type-'+index">{{value}}</label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
        <li :class="{'open': openFilters.orientation}">
            <a href="#" class="toggle-filter" @click.prevent="openFilters.orientation = !openFilters.orientation">Orientation</a>
            <ul>
                <li v-for="(value, key, index) in filters.orientation" :class="'image-label '+key+'-image'"><input type="radio" :value="key" :id="'image-orientation-'+index" v-model="activeFilters.orientation"> <label :for="'image-orientation-'+index">{{value}}</label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
        <li class="color-filter" :class="{'open': openFilters.color}">
            <span>Color</span>
            <input placeholder="None" class="color-picker" v-model="activeFilters.color" readonly @click.prevent="openFilters.color = !openFilters.color" />
            <a href="#" class="toggle-filter" @click.prevent="openFilters.color = !openFilters.color">Color</a>
            <ul>
                <li v-for="(color, index) in colors"><input type="radio" v-model="activeFilters.color" :value="color" :id="'color-picker-'+index" class="sr-only"><label :for="'color-picker-'+index" :style="{'background':color}"><span class="sr-only">{{color}}</span></label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
    </ul>
    <div class="applied-filters">
        <a href="#" class="remove-all" v-if="hasApplied" @click.prevent="reset()">remove all filters</a>
        <a href="#" class="text-link" v-if="appliedFilters.type !== 'all'" @click.prevent="remove('type','all')">{{filters.type[appliedFilters.type]}}</a>
        <a href="#" :class="'text-link image-link '+appliedFilters.orientation+'-image'" v-if="appliedFilters.orientation !== 'all'" @click.prevent="remove('orientation','all')">{{filters.orientation[appliedFilters.orientation]}}</a>
        <a href="#" class="text-link" v-if="appliedFilters.color !== null" @click.prevent="remove('color',null)">Color: {{appliedFilters.color}}</a>
    </div>
    </div>
    `,
    props: {

    },
    methods: {
        apply() {
            this.closeAll();
            this.$emit('updateFilters', this.cloneObject(this.activeFilters));
        },
        reset() {
            this.activeFilters = this.cloneObject(this.cleanFilters);
            this.$emit('updateFilters', this.cloneObject(this.cleanFilters));
        },
        remove(type,value) {
            this.activeFilters[type] = value;
            this.apply();
        },
        closeAll() {
            for(const filter in this.openFilters) {
                this.openFilters[filter] = false;
            }
        }
    }
}
const facetsComponent = {
    inject: ['page','limit'],
    emits: ['updateLimit'],
    data() {
        return {
            currentLimit: this.limit,
            options: ['20','40','60'] // Maximum number of assets to return in the call. Valid values are 1 through 64.
        }
    },
    template: `<form id="FacetFiltersForm" class="facets__form">
            <div class="product-count" role="status">
              <div class="product-count__text text-body"><span id="ProductCountDesktop" v-html="itemsCount()"></span></div>
            </div>
            <div class="limiter">
              <label for="limiter">Images per page: </label>
              <label for="limiter-mobile" class="sr-only">Images per page: </label>
              <select id="limiter" v-model="currentLimit" @change="$emit('updateLimit', currentLimit)">
                <option v-for="option in options" :value="option">{{ option }}</option>
              </select>
              <select id="limiter-mobile" v-model="currentLimit" @change="$emit('updateLimit', currentLimit)">
                <option v-for="option in options" :value="option">{{ option }} per page</option>
              </select>
            </div>
          </form>`,
    props: {
        products: Array,
        total: Number,
        pages: Array
    },
    methods: {
        itemsCount() {
            let html = '';
            if(this.total === 1) {
                html = '<span class="collection-item-count">1 of 1</span>';
            } else if (this.total > 1) {
                let from = (this.page * this.limit) - this.limit + 1;
                let to = this.page * this.limit;
                if(to > this.total) {
                    to = this.total;
                }
                html = '<span class="collection-item-count">'+ from + ' - ' + to + ' of ' +this.total.toLocaleString()+'</span>';
            }
            return html;
        }
    }
}
const paginationComponent = {
    emits: ['paginate'],
    inject: ['page','loading'],
    template: `
    <nav aria-label="Page navigation" :data-page="currentPage" v-if="pages.length > 1">
      <ul class="pagination pagination-sm" :class="{'loading': loading}">
        <li class="page-item"><button type="button" class="page-link" :class="{ disabled: currentPage === 1}" @click.stop.prevent="goto(1)">&laquo;</button></li>
        <li class="page-item"><button type="button" class="page-link" :class="{ disabled: currentPage === 1}" @click.stop.prevent="prev()">&lsaquo;</button></li>
        <li class="page-item" v-for="pageNumber in currentPages"><button type="button" class="page-link" :class="{ active: currentPage === pageNumber}" @click.stop.prevent="goto(pageNumber)">{{pageNumber}}</button></li>
        <li class="page-item"><button type="button" @click.stop.prevent="next()" :class="{ disabled: currentPage >= pages.length}" class="page-link">&rsaquo;</button></li>
        <li class="page-item"><button type="button" @click.stop.prevent="goto(pages.length)" :class="{ disabled: currentPage >= pages.length}" class="page-link">&raquo;</button></li>
      </ul>
    </nav>`,
    props: {
        pages: Array
    },
    computed: {
        currentPage() {
            return this.page;
        },
        currentPages() {
            if(this.currentPage < 4) {
                return this.pages.slice(0, 5);
            } else {
                return this.pages.slice(this.currentPage-3, this.currentPage+2);
            }
        }
    },
    methods: {
        goto(pageNumber) {
            this.$emit('paginate',pageNumber);
        },
        prev() {
            this.$emit('paginate',(this.currentPage-1));
        },
        next() {
            this.$emit('paginate',(this.currentPage+1));
        }
    }
}
const collectionComponent = {
    components: {
        'product': productComponent,
        'facets': facetsComponent,
        'filters': filtersComponent,
        'pagination': paginationComponent,
        'wishlist': wishlistLink,
    },
    data() {
        return {
            exploreGridId: 'exploreGrid',
        }
    },
    inject: ['loading','loaded','hasFiltersInUrl','hasFilters','page','pages','limit','total','products','type','active'],
    emits: ['paginate','updateLimit','updateFilters','openSamplePopup','activate'],
    watch: {
        type() {
            setTimeout(() => {
                this.$redrawVueMasonry()
            },500)
        },
        products() {
            setTimeout(() => {
                this.$redrawVueMasonry()
            },500)
        },
    },
    template: `
    <div id="main-collection-filters" v-if="loaded && products.length > 0">
      <div class="facets-container">
        <div class="facets">
          <facets :products="products" :total="total" :pages="pages" @update-limit="updateLimit"></facets>
        </div>
        <div class="toolbar">
          <pagination :pages="pages" @paginate="paginate"></pagination>
        </div>
      </div>
    </div>
    <div class="api-collection-grid">
      <div class="row" v-if="loading">
        <div v-for="n in 30" :key="n" class="col-xl-3 col-lg-4 col-6">
          <div class="placeholder-container">
            <div class="content">
            </div>
          </div>
        </div>
      </div>
      <ul class="messages" v-if="loaded && products.length === 0"><li class="error-msg"><span>No products found</span></li></ul>
      <div class="images-grid row row-cols-2 row-cols-sm-3 row-cols-lg-5" v-masonry column-width=".grid-sizer" item-selector=".item">
        <div class="grid-sizer"></div>
      <template v-for="(product, index) in products" :key="product.id">
        <product :product="product" @open-sample-popup="openSamplePopup" @activate="activate"></product>
      </template>
      </div>
    </div>
    <div class="toolbar-bottom" v-if="loaded && products.length > 0">
      <pagination :pages="pages" @paginate="paginate"></pagination>
    </div>`,
    data() {
        return {}
    },
    mounted () {
        //this.observeGrid();
    },
    computed: {},
    methods: {
        paginate(currentPage) {
            this.$emit('paginate', currentPage);
        },
        updateLimit(currentLimit) {
            this.$emit('updateLimit', currentLimit);
        },
        updateFilters(newFilters) {
            this.$emit('updateFilters', newFilters);
        },
        openSamplePopup(product) {
            this.$emit('openSamplePopup', product);
        },
        activate(id) {
            this.$emit('activate', id);
        }
    }
}
if(rootEl) {
    const collectionApp = Vue.createApp({
        components: {
            'collection': collectionComponent,
            'product': productComponent,
            'facets': facetsComponent,
            'filters': filtersComponent,
            'pagination': paginationComponent,
            'sample': samplePopup,
            'wishlist': wishlistLink,
        },
        props: ['tag'],
        data() {
            return {
                id: null,
                categoryTree: [{"id":1,"link":"animals","name":"Animals"},{"id":96,"link":"buildings-and-architecture","name":"Buildings and Architecture"},{"id":167,"link":"business","name":"Business"},{"id":214,"link":"drinks","name":"Drinks"},{"id":240,"link":"the-environment","name":"The Environment"},{"id":261,"link":"states-of-mind","name":"States of Mind"},{"id":289,"link":"food","name":"Food"},{"id":444,"link":"graphic-resources","name":"Graphic Resources"},{"id":498,"link":"hobbies-and-leisure","name":"Hobbies and Leisure"},{"id":568,"link":"industry","name":"Industry"},{"id":596,"link":"landscapes","name":"Landscapes"},{"id":643,"link":"lifestyle","name":"Lifestyle"},{"id":695,"link":"people","name":"People"},{"id":782,"link":"plants-and-flowers","name":"Plants and Flowers"},{"id":832,"link":"culture-and-religion","name":"Culture and Religion"},{"id":851,"link":"science","name":"Science"},{"id":888,"link":"social-issues","name":"Social Issues"},{"id":922,"link":"sports","name":"Sports"},{"id":981,"link":"technology","name":"Technology"},{"id":1013,"link":"transport","name":"Transport"},{"id":1043,"link":"travel","name":"Travel"}],
                page: 1,
                limit: 60,
                pages: [],
                total: 0,
                active: 0,
                accessToken: null,
                stock: null,
                iterator: null,
                apiFilters: {},
                products: [],
                hasFilters: false,
                hasFiltersInUrl: false,
                mediaQuery: null,
                isMounted: false,
                show: false,
                loading: true,
                keyword: null,
                type: 'mural',
                sampleItem: null,
                showSamplePopup: false,
                loaded: false,
                cleanFilters: {
                    'type': 'all',
                    'orientation': 'all',
                    'units': 'inches',
                    'min_width': null,
                    'min_height': null,
                    'color': null,
                },
                appliedFilters: {
                    'type': 'all',
                    'orientation': 'all',
                    'units': 'inches',
                    'min_width': null,
                    'min_height': null,
                    'color': null,
                }
            }
        },
        provide() {
            return {
                page: Vue.computed(() => parseInt(this.page)),
                limit: Vue.computed(() => parseInt(this.limit)),
                pages: Vue.computed(() => this.pages),
                total: Vue.computed(() => parseInt(this.total)),
                products: Vue.computed(() => this.products),
                loading: Vue.computed(() => this.loading),
                loaded: Vue.computed(() => this.loaded),
                appliedFilters: Vue.computed(() => this.appliedFilters),
                hasFiltersInUrl: Vue.computed(() => this.hasFiltersInUrl),
                hasFilters: Vue.computed(() => this.hasFilters),
                cleanFilters: this.cleanFilters,
                type: Vue.computed(() => this.type),
                active: Vue.computed(() => this.active),
            }
        },
        created() {
            const params = new URLSearchParams(window.location.search);
            if(params.has('id') === true) {
                this.id = params.get('id');
            }
            // filters
            for(const filter in this.cleanFilters) {
                if(params.has(filter) === true) {
                    this.appliedFilters[filter] = decodeURIComponent(params.get(filter));
                    this.hasFiltersInUrl = true;
                }
            }
            // page
            if(params.has('p') === true) {
                this.page = parseInt(params.get('p')) ? parseInt(params.get('p')) : 1
            }
            if(params.has('q') === true) {
                this.keyword = decodeURIComponent(params.get('q'));
            }
            this.mediaQuery = window.matchMedia('(min-width:992px)');
            this.mediaQuery.addListener(this.handleResize.bind(this));
        },
        computed: {
            currentCategory() {
                return this.categoryTree.find((c) => c.link === this.tag) ?? null;
            },
            getLimit() {
                return parseInt(this.limit);
            },
            getPage() {
                return parseInt(this.page);
            }
        },
        mounted () {
            this.isMounted = true;
            if(this.hasFiltersInUrl) {
                this.searchWithFilters();
            } else {
                this.search();
            }
            this.getProducts();
        },
        methods: {
            handleResize() {
                if (this.mediaQuery.matches) {
                    this.show = false;
                }
            },
            load() {
                let reset = true;
                let newParams = {'p':null};
                for(const filter in this.appliedFilters) {
                    newParams[filter] = null;
                    if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                        newParams[filter] = this.appliedFilters[filter];
                        reset = false;
                    }
                }
                this.page = 1;
                if(reset) {
                    this.search();
                    this.setQueryStringParameter(newParams, true);
                } else {
                    this.searchWithFilters();
                    this.setQueryStringParameter(newParams);
                }
                this.getProducts();
            },
            reset() {
                this.keyword = null;
                this.load();
            },
            search() {
                let filters = this.cloneObject(this.xApiFilters);
                if(this.currentCategory) {
                    filters['search_parameters']['category'] = this.currentCategory.id;
                } else {
                    filters['search_parameters']['order'] = 'featured';
                }
                if(this.keyword) {
                    filters['search_parameters']['words'] = this.keyword;
                    filters['search_parameters']['order'] = 'relevance';
                } else {
                    filters['search_parameters']['words'] = 'art+and+nature';
                }
                filters['search_parameters']['limit'] = this.getLimit;
                //filters['search_parameters']['filters_orientation'] = 'square';
                if(this.id) {
                    if(filters['search_parameters'].hasOwnProperty('words') && filters['search_parameters']['words']) {
                        delete filters['search_parameters']['words'];
                    }
                    filters['search_parameters']['media_id'] = this.id;
                }
                this.loading = true;
                this.hasFilters = false;
                this.apiFilters = this.cloneObject(filters);
            },
            searchWithFilters() {
                let filters = this.cloneObject(this.xApiFilters);
                if(this.currentCategory) {
                    filters['search_parameters']['category'] = this.currentCategory.id;
                } else {
                    filters['search_parameters']['order'] = 'nb_downloads';
                }
                if(this.keyword) {
                    filters['search_parameters']['words'] = this.keyword;
                    filters['search_parameters']['order'] = 'relevance';
                }
                filters['search_parameters']['limit'] = this.getLimit;
                // Image Type
                if(this.appliedFilters.type !== 'all') {
                    delete filters.search_parameters.filters_content_type_photo;
                    switch (this.appliedFilters.type) {
                        case 'photo':
                            filters['search_parameters']['filters_content_type_photo'] = 1;
                            break;
                        case 'illustration':
                            filters['search_parameters']['filters_content_type_illustration'] = 1;
                            break;
                        case 'vector':
                            filters['search_parameters']['filters_content_type_vector'] = 1;
                            break;
                    }
                }
                // Orientation
                if(this.appliedFilters.orientation !== 'all') {
                    switch (this.appliedFilters.orientation) {
                        case 'horizontal':
                            filters['search_parameters']['filters_orientation'] = 'horizontal';
                            break;
                        case 'vertical':
                            filters['search_parameters']['filters_orientation'] = 'vertical';
                            break;
                        case 'square':
                            filters['search_parameters']['filters_orientation'] = 'square';
                            break;
                        case 'panoramic':
                            filters['search_parameters']['filters_panoramic_on'] = 1;
                            break;
                    }
                }
                // Size
                const inMultiplier = 15;
                const cmToIn = 0.393701;
                let $width = null;
                let $height = null;
                if(this.appliedFilters.min_width && this.appliedFilters.min_width > 0) {
                    if(this.appliedFilters.units === 'inches') {
                        $width = this.appliedFilters.min_width * inMultiplier;
                    } else {
                        $width = this.appliedFilters.min_width * cmToIn * inMultiplier;
                    }
                }
                if(this.appliedFilters.min_height && this.appliedFilters.min_height > 0) {
                    if(this.appliedFilters.units === 'inches') {
                        $height = this.appliedFilters.min_height * inMultiplier;
                    } else {
                        $height = this.appliedFilters.min_height * cmToIn * inMultiplier;
                    }
                }
                if($width && !$height) {
                    $height = $width;
                } else if(!$width && $height) {
                    $width = $height;
                }
                if($width && $height) {
                    const $area = Math.ceil($width * $height);
                    filters['search_parameters']['filters_area_pixels'] =  '0-'+$area;
                }
                // Color
                if(this.appliedFilters.color) {
                    filters['search_parameters']['filters_colors'] = this.appliedFilters.color.replace('#','');
                }
                if(this.id) {
                    if(filters['search_parameters'].hasOwnProperty('words') && filters['search_parameters']['words']) {
                        delete filters['search_parameters']['words'];
                    }
                    filters['search_parameters']['media_id'] = this.id;
                }
                this.loading = true;
                this.hasFilters = true;
                this.apiFilters = this.cloneObject(filters);
            },
            getProducts() {
                const index = this.getPage - 1;
                const apiFilters = this.cloneObject(this.apiFilters);
                const fetchHeaders = new Headers({'Content-Type':'application/json'});
                apiFilters['p'] = index;
                fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(apiFilters), headers: fetchHeaders})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.files) {
                            this.products = response.files;
                            this.total = parseInt(response.nb_results);
                        }
                    }).catch((error) => {
                        console.error(error);
                    }).then(() => {
                        this.setPages();
                    }).finally(() => {
                        this.loading = false;
                        this.loaded = true;
                    });
            },
            paginate(newPage) {
                if(newPage) {
                    if(newPage > 1) {
                        this.setQueryStringParameter({'p':newPage});
                    } else {
                        this.setQueryStringParameter({'p':newPage},true);
                    }
                    this.loading = true;
                    this.page = parseInt(newPage);
                    this.getProducts();
                    this.scrollTo(0);
                }
            },
            updateLimit(newLimit) {
                this.loading = true;
                this.page = 1;
                this.limit = newLimit;
                this.search();
                this.getProducts();
                this.scrollTo(0);
            },
            updateFilters(newFilters) {
                this.appliedFilters = newFilters;
                let reset = true;
                let newParams = {'p':null};
                for(const filter in this.appliedFilters) {
                    newParams[filter] = null;
                    if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                        newParams[filter] = this.appliedFilters[filter];
                        reset = false;
                    }
                }
                this.page = 1;
                if(reset) {
                    this.search();
                    this.setQueryStringParameter(newParams, true);
                } else {
                    this.searchWithFilters();
                    this.setQueryStringParameter(newParams);
                }
                this.getProducts();
            },
            openSamplePopup(product) {
                this.sampleItem = product;
                this.showSamplePopup = true;
            },
            closeSamplePopup() {
                this.showSamplePopup = false;
            },
            setPages() {
                let newPages = [];
                let numberOfPages = Math.ceil(this.total / this.getLimit);
                // limit total number of pages to 25
                if(numberOfPages > 25) {
                    numberOfPages = 25;
                }
                for (let index = 1; index <= numberOfPages; index++) {
                    newPages.push(index);
                }
                this.pages = newPages;
            },
            scrollTo(pos) {
                window.scrollTo({ top: pos, behavior: 'instant' });
            },
            setQueryStringParameter(newParams, remove) {
                const currentParams = new URLSearchParams(window.location.search);
                remove = (typeof remove === 'undefined') ? false : remove;
                if(remove) {
                    for(const name in newParams) {
                        currentParams.delete(name);
                    }
                } else {
                    for(const name in newParams) {
                        if(newParams[name]) {
                            currentParams.set(name, encodeURIComponent(newParams[name]));
                        } else {
                            currentParams.delete(name);
                        }
                    }
                }
                if(this.keyword) {
                    currentParams.set('q', encodeURIComponent(this.keyword));
                }
                window.history.pushState('', '', window.location.pathname + '?' + currentParams.toString());
            },
            openMenu() {
                document.body.classList.add('overflow-hidden')
                this.show = true;
            },
            closeMenu() {
                this.show = false;
                document.body.classList.remove('overflow-hidden')
            },
            activate(id) {
                this.active = id;
            }
        }
    }, { ...rootEl.dataset });
    collectionApp.use(store);
    collectionApp.use(AdobeClientPlugin);
    collectionApp.use(VueMasonryPlugin);
    collectionApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches')
    collectionApp.config.unwrapInjectedRef = true
    collectionApp.mount('#collectionApp');
}
